// src/components/text3d.ts

import { IText } from 'fabric';

type FabricObjectWith3DEffect = IText & {
  _render_original_3d?: (ctx: CanvasRenderingContext2D) => void;
  is3d?: boolean;
  effectOptions?: {
    depth?: number;
    offsetX?: number;
    offsetY?: number;
    sideColorBase?: number;
    sideColor?: string; // e.g. a hex color '#333333'
  }
};

function custom3dRender(this: FabricObjectWith3DEffect, ctx: CanvasRenderingContext2D) {
  console.log('custom3dRender called', this.is3d, this.effectOptions);
  if (!this.is3d || !this.effectOptions || !this._render_original_3d) {
    // This should not happen if `enable3dEffect` is used correctly.
    // Fallback to original render if it exists
    this._render_original_3d?.(ctx);
    return;
  }

  const {
    depth = 10, // slightly less depth
    offsetX = 1,
    offsetY = 1,
    sideColorBase = 40,
    sideColor, // e.g. a hex color '#333333'
  } = this.effectOptions;

  ctx.save();
  
  const originalFill = this.fill;
  const originalStroke = this.stroke;

  // Render the extruded sides
  for (let i = depth; i > 0; i--) {
    let layerColor;
    if (sideColor) {
      layerColor = sideColor;
    } else {
      const shade = sideColorBase + (i / depth) * (200 - sideColorBase); // make it a bit brighter
      layerColor = `rgb(${Math.round(shade)},${Math.round(shade)},${Math.round(shade)})`;
    }
    
    this.fill = layerColor;
    // For simplicity, I'm removing stroke from the side layers.
    this.stroke = null; 

    ctx.save();
    ctx.translate(i * offsetX, i * offsetY);
    this._render_original_3d?.(ctx);
    ctx.restore();
  }

  // Restore original fill and stroke for the front face
  this.fill = originalFill;
  this.stroke = originalStroke;
  
  // Render the front face
  this._render_original_3d?.(ctx);

  ctx.restore();
}
export function enable3dEffect(textObject: IText, options: any) {
  console.log('enable3dEffect called', options);
  const obj = textObject as FabricObjectWith3DEffect;

  // First, disable any existing effect to be safe
  disable3dEffect(obj);

  if (!obj._render_original_3d) {
    obj._render_original_3d = obj._render.bind(obj);
  }

  obj.is3d = true;
  obj.effectOptions = options;
  obj._render = custom3dRender as any;
  obj.objectCaching = false;

  obj.dirty = true;
  obj.canvas?.requestRenderAll();
}

export function disable3dEffect(textObject: IText) {
  console.log('disable3dEffect called');
  const obj = textObject as FabricObjectWith3DEffect;

  if (obj._render_original_3d) {
    obj._render = obj._render_original_3d;
    delete obj._render_original_3d;
  }

  obj.is3d = false;
  delete obj.effectOptions;
  obj.objectCaching = true;

  obj.dirty = true;
  obj.canvas?.requestRenderAll();
}